import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArrowUpIcon = createIcon({
  displayName: 'ArrowUp',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M12,5v14"></path>
        <path d="M6.999,10l5.001,-5.001l5.001,5.001"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const ArrowUp: FC<IconProps> = (props) => {
  return <CustomIcon as={ArrowUpIcon} {...props} />
}

export default memo(ArrowUp)
